// Generated by https://quicktype.io

export interface Entity {
  id: string;
  type: string;
  status: string;
  firstName: string;
  lastName: string;
  email: string;
  extensionNumber: string;
  account: Account;
  phoneNumbers: PhoneNumber[];
  name: string;
  emails: string[];
  hasProfileImage: boolean;
  contactStatus: string;
  entityType: string;
}

export interface Account {
  id: string;
}

export interface PhoneNumber {
  phoneNumber: string;
  phoneType: string;
  formattedPhoneNumber?: string;
  usageType?: string;
  type?: string;
  primary?: boolean;
}
